// @flow

import NavigationGroup from './NavigationGroup';

export default NavigationGroup;
